










import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosBairroComplemento extends Vue {
    get bairrocomplemento () {
        return this.$store.state.cotacao.bairrocomplemento;
    }

    set bairrocomplemento ( value ) {
        this.$store.commit("SET_BAIRROCOMPLEMENTO", value);
    }

    get errorBairroComplemento () {
        return this.$store.state.errors.bairrocomplemento;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
